import PickerButton from '../PickerButton';
const Components = {
  button: PickerButton
};
export default Components;